import React from "react";
import Result from "./Result";
import { createUseStyles } from "react-jss";
import keyframes from "../../../styles/Keyframes";

const useStyles = createUseStyles((theme) => ({
  results: {
    position: "relative",
    fontWeight: "400",
    wordBreak: "break-word",
    color: "black",
    whiteSpace: "pre-line",
    WebkitOverflowScrolling: "touch",
    flexShrink: "100",
    backgroundColor: theme.lightWhite,
    width: "stretch",

    "@media only screen and (max-height: 450px), only screen and (max-width: 600px)": {
      borderRadius: "0px",
      height: "100%",
    },
    "&.full": { height: "100%" },
    "&.open": {
      animationName: "$open-side-window",
      animationDuration: "0.2s",
      animationTimingFunction: "ease-in-out",
      animationFillMode: "forwards",
    },
    "&.close": {
      animationName: "$close-side-window",
      animationDuration: "0.2s",
      animationTimingFunction: "ease-in-out",
      animationFillMode: "forwards",
    },
    upperShadow: {
      position: "absolute",
      zIndex: "3",
      height: "13px",
      WebkitBoxShadow: "0px 20px 25px -14px rgba(255, 255, 255, 0.7) inset",
      MozBoxShadow: "0px 20px 25px -14px rgba(255, 255, 255, 0.7) inset",
      boxShadow: "0px 20px 25px -14px rgba(255, 255, 255, 0.7) inset",
      width: "stretch",
    },
    resultsContainer: {
      position: "relative",
      margin: "0",
      padding: "1px 2px 3px 2px",
      width: "stretch",
      height: "fit-content",
      backgroundColor: theme.secondaryColor,
      clear: "both",
    },
  },
  ...keyframes,
}));
export default ({ state, results, sendEvent, onAddressClick }) => {
  const styles = useStyles();
  return (
    <div
      className={[
        styles.resultsContainer,
        styles.results,
        state ? styles.open : styles.close,
        (0.95 * window.innerHeight) / 100 < results.length ? styles.full : null,
      ]
        .filter((x) => x)
        .join(" ")}
    >
      {results.map((result, index) => (
        <Result
          key={index}
          result={result}
          sendEvent={sendEvent}
          tagText={true}
          shouldTruncate={true}
          onAddressClick={onAddressClick}
        />
      ))}
    </div>
  );
};
